import { render } from "./AssetRetirementReport.vue?vue&type=template&id=038f46d7"
import script from "./AssetRetirementReport.vue?vue&type=script&lang=js"
export * from "./AssetRetirementReport.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abola\\Documents\\A.Personal Dev\\CHI\\assetmentainance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__